export default {

    beforeCreate() {
        // Subscribe to store updates
        if (process.env.VUE_APP_DISABLE_SESSION_STORE != "true") { // Allow this featured to be disabled in local development
            this.$store.subscribe((mutation, state) => {
                // Store the state object as a JSON string
                sessionStorage.setItem(`store-${state.schema}wrapper`, JSON.stringify(state));
            });
        }
    },

    created() {
        if (process.env.VUE_APP_DISABLE_SESSION_STORE != "true") { // Allow this featured to be disabled in local development
            if (sessionStorage.getItem(`store-${this.$store.state.schema}wrapper`)) {
                this.$store.commit('initialiseStore');
            }
        }
	}
}